import { render, staticRenderFns } from "./AbhaConsentList.vue?vue&type=template&id=6c65daae"
import script from "./AbhaConsentList.vue?vue&type=script&lang=js"
export * from "./AbhaConsentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports